var React = require('react');

function ScaleLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.484 5.078a5 5 0 015-5h18a5 5 0 015 5v6.59a1 1 0 11-2 0v-6.59a3 3 0 00-3-3h-18a3 3 0 00-3 3v11.355a1 1 0 11-2 0V5.078zm1 19.827a1 1 0 011 1v9.913h24V31.2a1 1 0 112 0v11.414a5 5 0 01-5 5h-18a5 5 0 01-5-5V25.905a1 1 0 011-1zm25 12.913h-24v4.796a3 3 0 003 3h18a3 3 0 003-3v-4.795zM33.75 14.436a1 1 0 011.413-.057l6.5 6a1 1 0 010 1.47l-6.5 6a1 1 0 11-1.357-1.47l4.62-4.265H7.985a1 1 0 110-2h30.443l-4.62-4.265a1 1 0 01-.057-1.413z","key":0}),React.createElement("path",{"d":"M25.984 41.599a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z","key":1})]);
}

ScaleLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ScaleLight;

ScaleLight.default = ScaleLight;
